module.exports = __webpack_public_path__ + "img/zm.2d72eb17.svg";